import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import type { Product } from '../../../../types/product';

interface ProductViewHeaderProps {
  companyId: number;
  showFilters: boolean;
  onToggleFilters: () => void;
  hasProducts: boolean;
  selectedProductsMap: Map<number, Product>;
  onCreateProduct: () => void;
  onImportProducts: () => void;
  hasActiveFilters: boolean;
}

export const ProductViewHeader = ({
  companyId,
  showFilters,
  onToggleFilters,
  hasProducts,
  selectedProductsMap,
  onCreateProduct,
  onImportProducts,
  hasActiveFilters,
}: ProductViewHeaderProps) => {
  const navigate = useNavigate();

  const handleCompareAvailability = () => {
    if (selectedProductsMap.size === 0) return;

    const productIds = Array.from(selectedProductsMap.keys());
    navigate(`/companies/${companyId}/products/compare?productIds=${productIds.join(',')}`);
  };

  return (
    <>
      <Box
        sx={{
          position: 'sticky',
          top: 64,
          zIndex: 10,
          backgroundColor: 'background.default',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          py: 1,
          mb: 0.5,
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(`/companies/${companyId}/home`)}
          size="small"
        >
          На головну
        </Button>
        <Typography
          variant="button"
          component="h1"
          noWrap
          sx={{
            minWidth: 0,
            pr: { xs: '9px', sm: '10px' },
            color: 'primary.main',
          }}
        >
          Продукти
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: { xs: 1, sm: 2 },
          }}
        >
          <Tooltip title="Показати/сховати фільтри">
            <IconButton
              size="small"
              onClick={onToggleFilters}
              color={showFilters || hasActiveFilters ? 'primary' : 'default'}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Імпорт з Excel">
            <Button
              color="inherit"
              startIcon={<UploadFileIcon />}
              onClick={onImportProducts}
              sx={{ minWidth: { xs: 0, sm: 'auto' } }}
            >
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                Імпорт
              </Box>
            </Button>
          </Tooltip>

          {hasProducts && (
            <>
              <Tooltip title="Порівняти наявність">
                <span>
                  <Button
                    color="inherit"
                    startIcon={<CompareArrowsIcon />}
                    onClick={handleCompareAvailability}
                    disabled={selectedProductsMap.size === 0}
                    sx={{ minWidth: { xs: 0, sm: 'auto' } }}
                  >
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                      Порівняти наявність
                    </Box>
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={onCreateProduct}
              >
                Створити
              </Button>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};
